import { ApiClient } from "@/api-client/src/core/api-client";
import {
  AddToWishlistResponse,
  WishlistResponse,
} from "@/packages/types/wishlist";

const apiClient = new ApiClient();
const webService = apiClient.web;

export const fetchUserWishlist = async (): Promise<WishlistResponse> => {
  const response = await webService.get<WishlistResponse>(`/users/wishlist`);
  return response;
};
export const addToWishlist = async (data: {
  productId: number | string;
}): Promise<AddToWishlistResponse> => {
  const response = await webService.post<AddToWishlistResponse>(
    `/users/wishlist`,
    data
  );
  return response;
};
